import { MdCheckBoxOutlineBlank, MdCheckBox } from "react-icons/md";

export default function Behavior({id,name,value,setValue}) {

   function onToggleCheck() {
      setValue(id, value?"F":"T");
   }


   return (
      <div className="element" onClick={onToggleCheck}>
         <span className="columndata">{name}</span>
         <span className="checkbox"  >
            {value ?
               <MdCheckBox className="checkbox checked" /> :
               <MdCheckBoxOutlineBlank className="checkbox unchecked" />}
         </span>
      </div>
   );


   // return (
   //    <tr key={id}>
   //       <td className="columndata">{name}</td>
   //       <td className="checkbox" onClick={onToggleCheck} >
   //          {value ?
   //             <MdCheckBox className="checkbox checked" /> :
   //             <MdCheckBoxOutlineBlank className="checkbox unchecked" />}
   //       </td> 
   //    </tr>
   // );
}
